"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.new.title': 'Dodaj Nową Wiedzę',
    'shortcuts.new.description': 'Tworzy lub dodaje nową wiedzę do systemu',
};
